import React from 'react';
import { makeClassName } from '@siteless/util';
import { IconPropsType } from '../util/types';

const HandLeftIcon = ({ className, ...rest }: IconPropsType) => (
  <svg
    className={makeClassName('HandLeftIcon', className)}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    xmlSpace="preserve"
    {...rest}
  >
    <path
      d="M13.08,23.49c-4.18,0-7.44-2.12-9.97-6.47l-1.25-2.68c-0.6-1.28-0.04-2.81,1.24-3.41c0.95-0.45,2.01-0.29,2.75,0.3v-5.8
	c0-1.42,1.15-2.57,2.57-2.57c0.2,0,0.39,0.02,0.57,0.06V2.82c0-1.42,1.15-2.57,2.57-2.57c1.06,0,1.98,0.65,2.37,1.57
	c0.24-0.08,0.5-0.12,0.77-0.12c1.42,0,2.57,1.15,2.57,2.57v0.19c0.18-0.04,0.37-0.06,0.57-0.06c1.42,0,2.57,1.15,2.57,2.57v10.38
	C20.41,20.74,17.13,23.49,13.08,23.49z M4.24,12.67c-0.08,0-0.16,0.02-0.24,0.05c-0.34,0.16-0.46,0.5-0.33,0.78l1.21,2.6
	c2.1,3.6,4.79,5.39,8.2,5.39c2.94,0,5.33-1.86,5.33-4.15V6.96c0-0.31-0.26-0.57-0.57-0.57s-0.57,0.26-0.57,0.57v4.23
	c0,0.55-0.45,1-1,1c-0.55,0-1-0.45-1-1V4.27c0-0.31-0.26-0.57-0.57-0.57s-0.57,0.26-0.57,0.57v6.92c0,0.55-0.45,1-1,1
	c-0.55,0-1-0.45-1-1V2.82c0-0.31-0.26-0.57-0.57-0.57S11,2.51,11,2.82v8.37c0,0.55-0.45,1-1,1s-1-0.45-1-1V5.44
	c0-0.31-0.26-0.57-0.57-0.57S7.86,5.12,7.86,5.44v9.43c0,0.46-0.32,0.86-0.76,0.97c-0.45,0.11-0.91-0.1-1.12-0.51l-1.19-2.29
	C4.67,12.8,4.46,12.67,4.24,12.67z"
    />
  </svg>
);

export default HandLeftIcon;
